export type CoinGeckoMarketDataResponse = {
  id: string;
  symbol: string;
  name: string;
  image: string;
  current_price: number;
  market_cap: number;
  market_cap_rank: number;
  fully_diluted_valuation: number;
  total_volume: number;
  high_24h: number;
  low_24h: number;
  price_change_24h: number;
  price_change_percentage_24h: number;
  market_cap_change_24h: number;
  market_cap_change_percentage_24h: number;
  circulating_supply: number;
  total_supply: number;
  max_supply: number;
  ath: number;
  ath_change_percentage: number;
  ath_date: string;
  atl: number;
  atl_change_percentage: number;
  atl_date: string;
  roi: null;
  last_updated: string;
  sparkline_in_7d: { price: number[] };
};

export const getCoinGeckoMarketData = async (
  baseUrl: string,
  currency: string,
  tokenIds?: string,
  perPage?: number,
) => {
  try {
    const res = await fetch(
      `${baseUrl}/api/coingecko/coins/markets?vs_currency=${currency}${tokenIds ? `&ids=${tokenIds}` : ""}${perPage ? `&per_page=${perPage}` : ""}`,
      {
        credentials: "include",
      },
    );

    const data = (await res.json()) as CoinGeckoMarketDataResponse[];
    return data;
  } catch (error) {
    console.log("Error getting market data", error);
  }
};
